import { cx } from '@linaria/core';
import { Fragment } from 'react';
import { titleCls, spanCls, footerCls } from './footer.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function Footer(props) {
  if (!props.caption) {
    return null;
  }
  const content = [props.caption.title?.showInContext && props.includeTitle && /*#__PURE__*/jsx("span", {
    className: cx(titleCls, spanCls),
    dangerouslySetInnerHTML: {
      __html: props.caption.title.value
    }
  }), props.caption.caption?.showInContext && /*#__PURE__*/jsx("span", {
    className: spanCls,
    dangerouslySetInnerHTML: {
      __html: props.caption.caption.value
    }
  }), props.caption.authorOrArtist?.showInContext && /*#__PURE__*/jsx("span", {
    className: spanCls,
    dangerouslySetInnerHTML: {
      __html: props.caption.authorOrArtist.value
    }
  }), props.caption.country?.showInContext && /*#__PURE__*/jsx("span", {
    className: spanCls,
    dangerouslySetInnerHTML: {
      __html: props.caption.country.value
    }
  }), props.caption.duration?.showInContext && /*#__PURE__*/jsx("span", {
    className: spanCls,
    dangerouslySetInnerHTML: {
      __html: props.caption.duration.value
    }
  }), props.caption.year?.showInContext && /*#__PURE__*/jsx("span", {
    className: spanCls,
    dangerouslySetInnerHTML: {
      __html: props.caption.year.value
    }
  }), props.caption.copyright?.showInContext && props.caption.copyright.value && /*#__PURE__*/jsx("span", {
    className: spanCls,
    dangerouslySetInnerHTML: {
      __html: "©&nbsp;" + props.caption.copyright.value
    }
  })].filter(it => !!it);
  if (!content.length) {
    return null;
  }
  return /*#__PURE__*/jsx("footer", {
    className: cx(footerCls, props.scrambled && "scrambled"),
    children: content.map((item, index) => /*#__PURE__*/jsxs(Fragment, {
      children: [item, " "]
    }, index))
  });
}

export { Footer };
//# sourceMappingURL=footer.js.map
